import { useContext } from 'react';
import ThemeContext, { ThemeData } from './ThemeContext';
import { Theme } from '../../types';

function useTheme() {
  const context = useContext<ThemeData>(ThemeContext);

  if (context === undefined) {
    throw new Error('useTheme: ThemeProvider missing');
  }

  return {
    theme: context.theme,
    isDefault: context.theme === Theme.DEFAULT,
    isBranded: context.theme === Theme.BRAND,
    isGhost: context.theme === Theme.GHOST,
    isTakeover: context.theme === Theme.TAKEOVER
  };
}

export default useTheme;
